import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  active: '',
};
export const sliceKey = 'activeDialer';

export const activeDialerSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    setActive: (state, { payload }) => {
      try {
        state.active = payload;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const { setActive } = activeDialerSlice.actions;

export default activeDialerSlice.reducer;
